import script from "./MintAssetControlsMintDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MintAssetControlsMintDetails.vue?vue&type=script&setup=true&lang=js"

import "./MintAssetControlsMintDetails.vue?vue&type=style&index=0&id=28fe85bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28fe85bb"]])

export default __exports__